//external
import React, { createContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router';
//internal
import Route from '../../routes/Route';
import EditRtpi from './edit';
import Rtpi from './list';
import RtpiView from './view';

export const FilterRtpi = createContext({});

export default function Routes() {
  const [filter, setFilter] = useState({
    search: "",
    branch: null,
    page: 1,
  });

  let location = useLocation();

  useEffect(() => {
    const split = location?.pathname.split('/');
    if (split[3] !== "rtpi") {
      setFilter({
        search: "",
        branch: null,
        page: 1,
      });
    }
  }, [location, setFilter]);

  return (
    <FilterRtpi.Provider value={{ filter, setFilter }}>
      <Route path="/premixlabel/rtpi/rtpi" exact component={Rtpi} isPrivate/>
      <Route path="/premixlabel/rtpi/rtpi/view/:branch/:protheusCode" exact component={RtpiView} isPrivate/>
      <Route path="/premixlabel/rtpi/rtpi/edit/:branch/:protheusCode/:revision" exact component={EditRtpi} isPrivate/>
    </FilterRtpi.Provider>
  )
}